const DURATIONS = {
  FAST: 150,
  REGULAR: 200,
  SLOW: 250
}

export default DURATIONS
